<template>
  <div :class="{'quick-start-banner--collapsed': isCollapsed}" class="quick-start-banner" data-cy="quick-start-banner">
    <div v-if="false" class="quick-start-banner__title">
      <!-- <h2>{{ isCollapsed ? '' : 'Create a new deck' }}</h2> -->
      <p />
      <b-button
        @click="toggleCollapsed"
        :icon-left="`angle-double-${isCollapsed ? 'down' : 'up'}`"
        icon-pack="fas"
        size="is-small"
      >
        {{ isCollapsed ? 'Expand Quick Access Bar' : 'Collapse' }}
      </b-button>
    </div>
    <transition name="fade">
      <HorizontalSlider v-if="!isCollapsed && sortedPublicDecks.length">
        <HorizontalSliderItem>
          <DeckBannerButton @click.native="newDeck" icon="plus" size="wide" label="Create New" class="secondary" data-cy="new-deck" />
        </HorizontalSliderItem>
        <HorizontalSliderItem>
          <DeckBannerButton @click.native="upload" img-src="/logos/powerpoint.svg" size="wide" label="Upload" class="powerpoint" />
        </HorizontalSliderItem>
        <HorizontalSliderItem v-for="deck in sortedPublicDecks" :key="'deck-item-' + deck?.id">
          <DeckBannerLink
            @click.native="captureBannerLinkClick(deck)"
            :label="deck.name"
            :subtitle="`${deck.slideCount} slide${pluralize(deck.slideCount)}`"
            :image="getImageUrl(deck)"
            :themeData="deck.themeData"
            :link="`/preview/${deck?.id}`"
            data-cy="deck-banner-link"
          />
        </HorizontalSliderItem>
        <HorizontalSliderItem>
          <DeckBannerButton @click.native="browseTemplates" img-src="/illustrations/rating-click.svg" size="wide" label="Browse All" class="gray" />
        </HorizontalSliderItem>
      </HorizontalSlider>
    </transition>
  </div>
</template>

<script>
import shuffle from 'lodash.shuffle'

import HorizontalSliderItem from '../horizontal-slider/HorizontalSliderItem.vue'
import HorizontalSlider from '~/components/horizontal-slider/HorizontalSlider.vue'
import DeckBannerButton from '~/components/decks/quick-start-banner/DeckBannerButton.vue'
import DeckBannerLink from '~/components/decks/quick-start-banner/DeckBannerLink.vue'
import { getPublicDecks } from '~/queries/getPublicDecks'
import { quickStartDecks } from '~/common/decks'

export default {
  name: 'QuickStartBanner',
  components: { HorizontalSliderItem, HorizontalSlider, DeckBannerButton, DeckBannerLink },
  data () {
    return {
      isCollapsed: false
    }
  },
  apollo: {
    publicDecks: {
      query: getPublicDecks,
      variables () {
        return {
          ids: this.quickStartDeckIds
        }
      },
      update (data) {
        return data.slideDecks
      }
    }
  },
  computed: {
    quickStartDeckIds () {
      const ids = quickStartDecks.filter((deck) => {
        const now = new Date()
        const today = `${('0' + (now.getMonth() + 1)).slice(-2)}/${('0' + now.getDate()).slice(-2)}`
        return deck.userTypes.includes(this.$store.state.user.isEdu ? 'edu' : 'work') && (!deck.seasonal || (deck.seasonal.start <= today && deck.seasonal.end >= today))
      }).map(deck => deck?.id)

      return ids
    },
    sortedPublicDecks () {
      if (!this.publicDecks) {
        return []
      }
      const decks = this.quickStartDeckIds.map((id) => {
        return this.publicDecks.find(deck => deck?.id === id)
      }).filter(deck => deck?.id)

      return shuffle(decks)
    }
  },
  mounted () {
    this.isCollapsed = this.hasOnboarded('quick-start-banner--collapsed')
    this.posthogCapture('onboard:start_banner_shown')
  },
  methods: {
    toggleCollapsed () {
      this.isCollapsed = !this.isCollapsed
      this.saveOnboarding('quick-start-banner--collapsed', !this.isCollapsed)
    },
    getImageUrl (deck) {
      const src = deck.themeData.background?.bgImage
      return src ? this.cfResize(src, { w: 192, h: 128, fit: 'scale-down' }) : ''
    },
    newDeck () {
      this.posthogCapture('onboard:start_banner_blank_click', { click_intent: 'create blank' })
      this.$emit('new-deck')
    },
    upload () {
      this.posthogCapture('onboard:start_banner_import_click', { click_intent: 'import deck' })
      this.$emit('upload')
    },
    browseTemplates () {
      this.posthogCapture('onboard:start_banner_browse_click', { click_intent: 'browse templates' })
      this.$router.push('/templates')
    },
    captureBannerLinkClick (deck) {
      this.posthogCapture('onboard:start_banner_deck_click', { click_intent: 'preview deck', template_id: deck?.id, template_name: deck?.name })
    }
  }
}
</script>

<style scoped lang="scss">
@import "/assets/css/components";

.quick-start-banner {
  min-height: 200px;
  margin: -3rem -3rem $margin-75;
  background-color: rgba(70,125,180,.05);
  border-bottom: 1px solid var(--med-blue);

  &--collapsed {
    margin-bottom: $margin-4;
  }

  h2 {
    font-size: $font-size-3;
    margin: 0;
  }

  button {
    margin-right: -1rem;
  }
}

.quick-start-banner__title {
  margin-bottom: $margin-3;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
